<div>
  Here is the data panel component...ready for action (almost)
</div>